import { Dispatch, useCallback } from 'react';
import { VoidCb } from '../../types/others';

export default function useBoolStateCb(
  setState: Dispatch<boolean>,
): [VoidCb, VoidCb] {
  const _set = useCallback(() => setState(true), [setState]);
  const clear = useCallback(() => setState(false), [setState]);
  return [_set, clear];
}
